// extracted by mini-css-extract-plugin
export default {"list":"color-field_list__Z0-zg","box":"color-field_box__Lcx3c","checked":"color-field_checked__oA9rj","indicator":"color-field_indicator__n5OxO"};